import request from '@/utils/request'

const ApiClient = '/api/tree/client'
const ApiIndustry = '/api/tree/industry'
const ApiOrganisation = '/api/tree/organisation'

export default {
  getIndustryList: () => request.json(`${ApiIndustry}/list/`, {cache: true}),

  getClientsDetail: () => request.json(`${ApiClient}/list/`, {cache: true}),

  getOrganisationList: ({includeArchived = false} = {}) =>
    request.json(`${ApiOrganisation}/list/`, {
      params: includeArchived ? {include_archived: 1} : {},
    }),

  postOrganisationDetail: ({id, ...data}) =>
    request.post(`${ApiOrganisation}/${id}/`, data),

  // Toggle archive state — backend stays the source of truth
  // (data still exists; only filter dropdowns / hierarchy
  // picker hide archived rows). May-2026 customer-settings v2.
  postOrganisationArchive: (id, isArchived) =>
    request.post(`${ApiOrganisation}/${id}/archive/`, {is_archived: isArchived}),

  // Merge a set of organisations into one winner. One-way —
  // backend has no unmerge path (see backend tree/cleaners.py
  // docstring). Caller is responsible for confirming via the
  // modal before sending. May-2026 customer-settings v2.
  postOrganisationMerge: ({organisations, primaryOrganisation, overrideName, overrideCode}) =>
    request.post(`${ApiOrganisation}/merge/`, {
      organisations,
      primary_organisation: primaryOrganisation,
      override_name: overrideName || '',
      override_code: overrideCode || '',
    }),

  getHierarchyList: (params = {}) => {
    return request.json('/api/tree/', {cache: true, params})
  },

  getHierarchyTopList: () => {
    return request.json('/api/tree/flat/?top', {cache: true})
  },

  getHierarchyNodeList: (nodeId) => {
    return request.json(`/api/tree/node/${nodeId}/`, {cache: true})
  },
}
